import { Group, Stack } from '@mantine/core';
import { Button, Icon, Text } from '@repo/foundations';
import type { AgentsEmptyStateProps } from '../types';

export function AgentsEmptyState({
	onCreate,
	onLearnMore,
}: AgentsEmptyStateProps) {
	return (
		<Stack align="center" justify="center" spacing="md" h="100%">
			<Icon name="click" size="lg" color="icon/secondary/default" />
			<Stack spacing="2xs" align="center" px="md">
				<Text size="sm" fw={700} align="center">
					Automate AI Workflows
				</Text>
				<Text size="sm" color="text/secondary/default" align="center">
					Create custom agents powered by Secoda&apos;s multi-agents and
					comprehensive tools to automate your data governance, analysis, and
					operational workflows.
				</Text>
			</Stack>
			<Group spacing="sm">
				<Button variant="default" onClick={onLearnMore}>
					Learn more
				</Button>
				<Button variant="primary" onClick={onCreate}>
					Create agent
				</Button>
			</Group>
		</Stack>
	);
}
